/* MATOSHI — Web Components. No framework, no build step. */
(function () {
  'use strict';
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (value) { return window.MatoshiEscape(value); };

  /* ---------- focus trap helper ---------- */
  var SEL = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function trap(container, onEscape) {
    var prev = document.activeElement;
    function key(e) {
      if (e.key === 'Escape') { e.preventDefault(); onEscape(); return; }
      if (e.key !== 'Tab') return;
      var f = $$(SEL, container).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    document.addEventListener('keydown', key);
    return function release() {
      document.removeEventListener('keydown', key);
      if (prev && prev.focus) prev.focus();
    };
  }
  function lockScroll(on) {
    if (on) {
      var sb = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      if (sb > 0) document.body.style.paddingRight = sb + 'px';
    } else { document.body.style.overflow = ''; document.body.style.paddingRight = ''; }
  }

  /* ---------- speed lines burst ---------- */
  var slTemplate = null;
  function burst(host) {
    if (reduced) return;
    if (!slTemplate) { var t = $('.speedlines'); if (!t) return; slTemplate = t; }
    var el = slTemplate.cloneNode(true);
    el.classList.add('is-burst');
    el.style.cssText = 'position:absolute;inset:-45%;pointer-events:none;z-index:0;color:currentColor';
    var cs = getComputedStyle(host);
    if (cs.position === 'static') host.style.position = 'relative';
    host.appendChild(el);
    setTimeout(function () { el.remove(); }, 520);
  }
  window.MatoshiBurst = burst;
  document.addEventListener('pointerenter', function (e) {
    var t = e.target.closest && e.target.closest('[data-burst]');
    if (t && !t.__b) { t.__b = 1; burst(t); setTimeout(function () { t.__b = 0; }, 600); }
  }, true);

  /* ---------- <announcement-bar> ---------- */
  customElements.define('announcement-bar', class extends HTMLElement {
    connectedCallback() {
      this.items = $$('.ann__item', this);
      this.i = 0;
      var close = $('.ann__close', this);
      if (close) close.addEventListener('click', () => {
        this.style.display = 'none';
        try { localStorage.setItem('matoshi.ann.dismissed', '1'); } catch (e) {}
      });
      try { if (localStorage.getItem('matoshi.ann.dismissed')) { this.style.display = 'none'; return; } } catch (e) {}
      if (this.items.length < 2 || reduced) return;
      this.timer = setInterval(() => this.next(), 6000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    next() {
      this.items[this.i].classList.remove('is-on');
      this.i = (this.i + 1) % this.items.length;
      this.items[this.i].classList.add('is-on');
    }
  });

  /* ---------- <site-header> ---------- */
  customElements.define('site-header', class extends HTMLElement {
    connectedCallback() {
      this.transparent = this.hasAttribute('data-transparent');
      this.onScroll = this.onScroll.bind(this);
      addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();

      // mega menu (desktop, hover + keyboard)
      $$('[data-mega-trigger]', this).forEach((btn) => {
        var panel = $('#' + btn.getAttribute('aria-controls'), this);
        if (!panel) return;
        var wrap = btn.closest('.nav__item');
        var closeTimer = null;
        var open = (v) => {
          clearTimeout(closeTimer);
          btn.setAttribute('aria-expanded', v);
          wrap.classList.toggle('is-open', v);
        };
        // Closing is delayed: the panel hangs below the whole header bar, so the
        // pointer has to cross a strip of dead space between the trigger and the
        // panel. Without the grace period that crossing fires pointerleave and
        // the menu vanishes just as the user reaches for it.
        var closeSoon = () => { clearTimeout(closeTimer); closeTimer = setTimeout(() => open(false), 260); };
        wrap.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse' && matchMedia('(min-width:1000px)').matches) open(true); });
        wrap.addEventListener('pointerover', (e) => { if (e.pointerType === 'mouse' && matchMedia('(min-width:1000px)').matches) clearTimeout(closeTimer); });
        wrap.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse' && matchMedia('(min-width:1000px)').matches) closeSoon(); });
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          // A click event fired by an actual pointer (mouse/pen/touch) carries
          // its device's pointerType; a click synthesized from keyboard
          // activation (Enter/Space on a focused button) does not. For mouse,
          // pointerenter above already opened the panel by the time this click
          // fires — toggling here would immediately close what the user just
          // hovered onto, so a mouse click only ever confirms "open" and
          // closing is left to pointerleave/Escape/focusout. Touch has no
          // hover-open, so it needs a real toggle; keyboard always does.
          if (e.pointerType === 'mouse' && matchMedia('(min-width:1000px)').matches) open(true);
          else open(btn.getAttribute('aria-expanded') !== 'true');
        });
        wrap.addEventListener('keydown', (e) => { if (e.key === 'Escape') { open(false); btn.focus(); } });
        wrap.addEventListener('focusout', (e) => { if (!wrap.contains(e.relatedTarget)) open(false); });
      });

      // mobile drawer
      var mBtn = $('[data-menu-toggle]', this), mNav = $('[data-mobile-nav]', this);
      if (mBtn && mNav) {
        var release = null;
        var setOpen = (v) => {
          mBtn.setAttribute('aria-expanded', v);
          mNav.toggleAttribute('hidden', !v);
          document.documentElement.classList.toggle('nav-open', v);
          lockScroll(v);
          if (v) { requestAnimationFrame(() => { mNav.classList.add('is-on'); var f = $(SEL, mNav); if (f) f.focus(); }); release = trap(mNav, () => setOpen(false)); }
          else { mNav.classList.remove('is-on'); if (release) { release(); release = null; } }
        };
        mBtn.addEventListener('click', () => setOpen(mBtn.getAttribute('aria-expanded') !== 'true'));
        $$('[data-menu-close]', mNav).forEach((b) => b.addEventListener('click', () => setOpen(false)));
        $$('[data-sub-toggle]', mNav).forEach((b) => b.addEventListener('click', () => {
          var on = b.getAttribute('aria-expanded') === 'true';
          b.setAttribute('aria-expanded', !on);
          var sub = b.nextElementSibling;
          if (sub) sub.toggleAttribute('hidden', on);
        }));
      }

      // cart count
      if (window.MatoshiCart) window.MatoshiCart.subscribe((c) => this.setCount(c.item_count));
      document.addEventListener('matoshi:cart:bounce', () => {
        var b = $('.cart-btn__count', this);
        if (b && !reduced) { b.classList.remove('is-bounce'); void b.offsetWidth; b.classList.add('is-bounce'); }
      });
    }
    setCount(n) {
      var b = $('.cart-btn__count', this);
      if (!b) return;
      b.textContent = n;
      b.toggleAttribute('hidden', !n);
      var l = $('.cart-btn__label', this);
      if (l) l.textContent = n + ' Artikel im Warenkorb';
    }
    onScroll() {
      var y = scrollY;
      this.classList.toggle('is-stuck', y > 40);
      if (this.transparent) this.classList.toggle('is-solid', y > 40);
    }
  });

  /* ---------- <predictive-search> ---------- */
  customElements.define('predictive-search', class extends HTMLElement {
    connectedCallback() {
      this.input = $('input[type=search]', this);
      this.out = $('[data-results]', this);
      this.panel = this;
      var openers = $$('[data-search-open]');
      this.release = null;
      openers.forEach((b) => b.addEventListener('click', () => this.open()));
      $$('[data-search-close]', this).forEach((b) => b.addEventListener('click', () => this.close()));
      this.addEventListener('click', (e) => { if (e.target === this) this.close(); });
      if (this.input) {
        var t;
        this.input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => this.search(this.input.value), 120); });
        this.input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); location.href = '/search/?type=product&q=' + encodeURIComponent(this.input.value); } });
      }
    }
    open() {
      this.removeAttribute('hidden');
      lockScroll(true);
      requestAnimationFrame(() => { this.classList.add('is-on'); if (this.input) this.input.focus(); });
      this.release = trap(this, () => this.close());
    }
    close() {
      this.classList.remove('is-on');
      lockScroll(false);
      if (this.release) { this.release(); this.release = null; }
      setTimeout(() => this.setAttribute('hidden', ''), 260);
    }
    async search(q) {
      if (!this.out) return;
      q = (q || '').trim().toLowerCase();
      this.query = q;
      var base = $('[data-search-default]', this);
      if (q.length < 2) { this.out.innerHTML = ''; if (base) base.removeAttribute('hidden'); return; }
      if (base) base.setAttribute('hidden', '');
      var list;
      if (window.Shopify) {
        if (this.searchController) this.searchController.abort();
        this.searchController = new AbortController();
        try {
          var root = (window.Shopify.routes && window.Shopify.routes.root) || '/';
          var response = await fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', {signal:this.searchController.signal});
          if (!response.ok) throw new Error('search');
          var data = await response.json();
          if (this.query !== q) return;
          list = data.resources.results.products.map(function (p) {
            return {title:p.title, url:p.url, image:p.image, series:p.vendor, price:Math.round(Number(p.price)*100)};
          });
        } catch (error) {
          if (error.name === 'AbortError' || this.query !== q) return;
          this.out.innerHTML = '<a class="tlink" href="/search?type=product&q=' + encodeURIComponent(q) + '">Suche öffnen</a>';
          return;
        }
      } else list = (window.__MATOSHI_PRODUCTS__ || []).filter(function (p) {
        return (p.title + ' ' + p.series + ' ' + p.type + ' ' + p.vendor).toLowerCase().indexOf(q) > -1;
      }).slice(0, 6);
      if (!list.length) { this.out.innerHTML = '<p class="ps__empty">Nichts gefunden. Sag uns, welche Figur fehlt – wir jagen sie.</p>'; return; }
      this.out.innerHTML = '<p class="eyebrow ps__lbl">' + list.length + ' Treffer</p>' + list.map(function (p) {
        return '<a class="ps__hit" href="' + esc(p.url) + '">' +
          '<img src="' + esc(window.MatoshiImg(p.image)) + '" alt="" width="56" height="70" loading="lazy">' +
          '<span class="ps__hit-txt"><span class="ps__hit-series">' + esc(p.series) + '</span>' +
          '<span class="ps__hit-title">' + esc(p.title) + '</span>' +
          '<span class="ps__hit-price num">' + window.MatoshiCart.format(p.price) + '</span></span></a>';
      }).join('') + '<a class="tlink ps__all" href="/search/?type=product&q=' + encodeURIComponent(q) + '">Alle Ergebnisse ansehen</a>';
    }
  });

  /* ---------- cart painting, shared by drawer and cart page ---------- */
  function lineHTML(i) {
    return '<li class="cline">' +
      '<a class="cline__img" href="' + esc(i.url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(i.image) + '" alt="" width="72" height="90" loading="lazy"></a>' +
      '<div class="cline__main">' +
        (i.series ? '<span class="cline__series">' + esc(i.series) + '</span>' : '') +
        '<a class="cline__title" href="' + esc(i.url) + '">' + esc(i.title) + '</a>' +
        (i.variant_title ? '<span class="cline__variant">' + esc(i.variant_title) + '</span>' : '') +
        (i.preorder ? '<span class="cline__pre">Pre-Order</span>' : '') +
        '<div class="cline__row">' +
          '<div class="qty qty--sm">' +
            '<button type="button" data-line-dec="' + i.key + '" data-qty="' + i.quantity + '" aria-label="Menge verringern">−</button>' +
            '<span class="num" aria-live="polite">' + i.quantity + '</span>' +
            '<button type="button" data-line-inc="' + i.key + '" data-qty="' + i.quantity + '" aria-label="Menge erhöhen">+</button>' +
          '</div>' +
          '<span class="cline__price num">' + window.MatoshiCart.format(i.line_price) + '</span>' +
        '</div>' +
      '</div>' +
      '<button class="cline__rm" type="button" data-line-remove="' + esc(i.key) + '" aria-label="' + esc(i.title) + ' entfernen">×</button>' +
    '</li>';
  }
  // Renders lines, totals and the free-shipping bar into any host that carries
  // the data-cart-* hooks. Returns false when the cart is empty.
  function paintCart(host, cart) {
    var body = $('[data-cart-body]', host), foot = $('[data-cart-foot]', host), empty = $('[data-cart-empty]', host);
    if (!body) return false;
    var fmt = window.MatoshiCart.format;
    $$('[data-cart-count]', host).forEach(function (c) { c.textContent = cart.item_count; });
    var bar = $('[data-ship-bar]', host);
    if (!cart.item_count) {
      body.innerHTML = ''; if (empty) empty.removeAttribute('hidden'); if (foot) foot.setAttribute('hidden', '');
      if (bar) bar.setAttribute('hidden', '');
      $$('[data-cart-filled]', host).forEach(function (el) { el.setAttribute('hidden', ''); });
      return false;
    }
    if (empty) empty.setAttribute('hidden', ''); if (foot) foot.removeAttribute('hidden');
    $$('[data-cart-filled]', host).forEach(function (el) { el.removeAttribute('hidden'); });
    body.innerHTML = cart.items.map(lineHTML).join('');
    $$('[data-cart-subtotal]', host).forEach(function (el) { el.textContent = fmt(cart.total_price); });
    if (bar) {
      bar.removeAttribute('hidden');
      var th = window.MatoshiCart.threshold(), left = th - cart.total_price;
      var fill = $('[data-ship-fill]', bar), txt = $('[data-ship-text]', bar);
      if (fill) fill.style.transform = 'scaleX(' + Math.min(1, cart.total_price / th) + ')';
      if (txt) txt.textContent = left > 0 ? 'Noch ' + fmt(left) + ' bis zum Gratis-Versand' : 'Gratis-Versand gesichert.';
      bar.classList.toggle('is-reached', left <= 0);
    }
    return true;
  }
  function bindLineControls(host) {
    host.addEventListener('click', function (e) {
      var dec = e.target.closest('[data-line-dec]'), inc = e.target.closest('[data-line-inc]'), rm = e.target.closest('[data-line-remove]');
      var button = dec || inc || rm;
      if (!button || host.busy) return;
      host.busy = true;
      host.setAttribute('aria-busy', 'true');
      var error = $('[data-cart-error]', host);
      if (error) error.textContent = '';
      window.MatoshiCart.change(button.dataset.lineDec || button.dataset.lineInc || button.dataset.lineRemove,
        rm ? 0 : parseInt(button.dataset.qty, 10) + (inc ? 1 : -1))
        .catch(function (reason) { if (error) error.textContent = reason.message; })
        .finally(function () { host.busy = false; host.removeAttribute('aria-busy'); });
    });
  }

  /* ---------- <cart-drawer> ---------- */
  customElements.define('cart-drawer', class extends HTMLElement {
    connectedCallback() {
      this.panel = $('.drawer__panel', this);
      this.release = null;
      $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); this.open(); }));
      $$('[data-cart-close]', this).forEach((b) => b.addEventListener('click', () => this.close()));
      this.addEventListener('click', (e) => { if (e.target === this) this.close(); });
      if (window.MatoshiCart) window.MatoshiCart.subscribe((c) => this.render(c));
      bindLineControls(this);
    }
    open() {
      this.removeAttribute('hidden'); lockScroll(true);
      requestAnimationFrame(() => { this.classList.add('is-on'); var f = $('[data-cart-close]', this); if (f) f.focus(); });
      this.release = trap(this, () => this.close());
    }
    close() {
      this.classList.remove('is-on'); lockScroll(false);
      if (this.release) { this.release(); this.release = null; }
      setTimeout(() => this.setAttribute('hidden', ''), 320);
    }
    render(cart) {
      if (!paintCart(this, cart)) { var cross = $('[data-cross-sell]', this); if (cross) cross.setAttribute('hidden', ''); return; }
      this.crossSell(cart);
    }
    crossSell(cart) {
      var host = $('[data-cross-sell]', this);
      if (!host) return;
      var all = window.__MATOSHI_PRODUCTS__ || [];
      var inCart = cart.items.map(function (i) { return i.handle; });
      // Shopify cart lines carry no series, so look it up in the product data island.
      var byHandle = {};
      all.forEach(function (p) { byHandle[p.handle] = p; });
      var seriesInCart = cart.items.map(function (i) {
        return i.series || (byHandle[i.handle] && byHandle[i.handle].series) || '';
      }).filter(Boolean);
      var hasScale = cart.items.some(function (i) { return i.product_type === 'Scale Figur'; });
      var fresh = function (p) { return inCart.indexOf(p.handle) < 0 && p.available; };
      var pool = [];
      if (hasScale) pool = all.filter(function (p) { return p.handle === 'matoshi-led-display-case-30-cm' && fresh(p); });
      if (pool.length < 2) pool = pool.concat(all.filter(function (p) { return fresh(p) && seriesInCart.indexOf(p.series) >= 0 && pool.indexOf(p) < 0; }));
      if (pool.length < 2) pool = pool.concat(all.filter(function (p) { return fresh(p) && pool.indexOf(p) < 0; }));
      pool = pool.slice(0, 2);
      if (!pool.length) { host.setAttribute('hidden', ''); return; }
      host.removeAttribute('hidden');
      var fmt = window.MatoshiCart.format;
      $('[data-cross-list]', host).innerHTML = pool.map(function (p) {
        return '<li class="xs"><a href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(window.MatoshiImg(p.image)) + '" alt="" width="48" height="60" loading="lazy"></a>' +
          '<div class="xs__t"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="num">' + fmt(p.price) + '</span></div>' +
          '<button class="xs__add" type="button" data-add-variant="' + p.variants[0].id + '" aria-label="' + esc(p.title) + ' hinzufügen">+</button></li>';
      }).join('');
    }
  });

  /* ---------- add to cart (delegated) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add-variant]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled || b.classList.contains('is-loading')) return;
    var id = b.getAttribute('data-add-variant');
    var qty = parseInt(b.getAttribute('data-qty') || '1', 10);
    if (!id) return;
    b.classList.add('is-loading');
    b.setAttribute('aria-busy', 'true');
    var lbl = b.querySelector('[data-atc-label]');
    var old = lbl ? lbl.textContent : null;
    // freeze the label width so the button doesn't jump when the text swaps
    if (lbl) lbl.style.minWidth = lbl.getBoundingClientRect().width + 'px';
    var restore = function (delay) {
      setTimeout(function () {
        b.classList.remove('is-done');
        if (lbl && old !== null) { lbl.textContent = old; lbl.style.minWidth = ''; }
        b.removeAttribute('aria-live');
      }, delay);
    };
    // Optimistisch: Haken sofort zeigen, bei Fehler zurücknehmen (Doppeltippen bleibt durch is-loading gesperrt)
    b.classList.add('is-done');
    if (lbl) lbl.textContent = 'Im Warenkorb';
    window.MatoshiCart.add(id, qty).then(function () {
      b.classList.remove('is-loading');
      try { if (navigator.vibrate) navigator.vibrate(12); } catch (err) {}
      burst(b);
      document.dispatchEvent(new CustomEvent('matoshi:cart:bounce'));
      var note = document.querySelector('cart-notification');
      if (note && note.show) note.show(id);
      restore(1800);
    }).catch(function () {
      b.classList.remove('is-loading', 'is-done');
      if (lbl) lbl.textContent = 'Gerade nicht möglich';
      b.setAttribute('aria-live', 'polite');
      restore(2200);
    }).finally(function () { b.removeAttribute('aria-busy'); });
  });

  /* ---------- <cart-notification> ---------- */
  customElements.define('cart-notification', class extends HTMLElement {
    show(variantId) {
      var all = window.__MATOSHI_PRODUCTS__ || [], hit = null;
      all.forEach(function (p) { p.variants.forEach(function (v) { if (String(v.id) === String(variantId)) hit = p; }); });
      if (!hit) return;
      $('[data-note-img]', this).src = window.MatoshiImg(hit.image);
      $('[data-note-title]', this).textContent = hit.title;
      this.removeAttribute('hidden');
      requestAnimationFrame(() => this.classList.add('is-on'));
      clearTimeout(this._t);
      this._t = setTimeout(() => this.hide(), 4200);
    }
    hide() { this.classList.remove('is-on'); setTimeout(() => this.setAttribute('hidden', ''), 320); }
    connectedCallback() {
      $$('[data-note-close]', this).forEach((b) => b.addEventListener('click', () => this.hide()));
    }
  });

  /* ---------- <cart-page> ---------- */
  customElements.define('cart-page', class extends HTMLElement {
    connectedCallback() {
      if (window.MatoshiCart) window.MatoshiCart.subscribe((c) => paintCart(this, c));
      bindLineControls(this);
    }
  });

  /* ---------- <quantity-input> ---------- */
  customElements.define('quantity-input', class extends HTMLElement {
    connectedCallback() {
      var input = $('input', this);
      $$('button', this).forEach((b) => b.addEventListener('click', () => {
        var d = b.dataset.dir === 'up' ? 1 : -1;
        var v = Math.max(1, Math.min(99, (parseInt(input.value, 10) || 1) + d));
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }));
    }
  });

  /* ---------- <variant-selects> ---------- */
  customElements.define('variant-selects', class extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse($('[type="application/json"]', this).textContent);
      this.addEventListener('change', () => this.update());
      $$('[data-opt]', this).forEach((el) => el.addEventListener('click', (e) => {
        if (el.tagName !== 'INPUT') return;
        setTimeout(() => this.update(), 0);
      }));
    }
    update() {
      var chosen = $$('input[type=radio]:checked, select', this).map(function (i) { return i.value; });
      var v = this.data.find(function (x) { return chosen.every(function (value, i) { return x['option' + (i + 1)] === value; }); });
      var form = this.closest('section') || document;
      var buttons = $$('[data-add-variant]', form).concat($$('sticky-atc [data-add-variant]'));
      buttons.forEach(function (btn) {
        btn.setAttribute('data-add-variant', v ? v.id : '');
        btn.disabled = !v || !v.available;
        var label = $('[data-atc-label]', btn);
        if (label) label.textContent = !v ? 'Nicht verfügbar' : v.available ? 'In den Warenkorb' : 'Ausverkauft';
      });
      if (!v) return;
      $$('[data-variant-price]', form).concat($$('sticky-atc [data-variant-price]')).forEach(function (price) { price.textContent = window.MatoshiCart.format(v.price); });
      var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      var stock = form.querySelector('[data-variant-stock]');
      if (stock) {
        stock.className = 'stockline ' + (v.available ? (v.inventory <= 5 ? 'is-low' : 'is-ok') : 'is-out');
        stock.textContent = v.available ? (v.inventory && v.inventory <= 5 ? 'Nur noch ' + v.inventory + ' Stück' : 'Auf Lager · sofort versandfertig') : 'Aktuell ausverkauft';
      }
      var lbl = form.querySelector('[data-atc-label]');
      if (lbl && !v.available) lbl.textContent = 'Ausverkauft – Drop-Alarm setzen';
    }
  });

  /* ---------- <accordion-item> via <details> is native; countdown ---------- */
  customElements.define('countdown-timer', class extends HTMLElement {
    connectedCallback() {
      this.render();
      this.t = setInterval(() => this.render(), 1000);
    }
    disconnectedCallback() { clearInterval(this.t); }
    target() {
      // next Friday 18:00 Europe/Berlin, always in the future
      var now = new Date();
      var d = new Date(now);
      var day = parseInt(this.dataset.day || '5', 10);
      var hour = parseInt(this.dataset.hour || '18', 10);
      d.setHours(hour, 0, 0, 0);
      var delta = (day - d.getDay() + 7) % 7;
      d.setDate(d.getDate() + delta);
      if (d <= now) d.setDate(d.getDate() + 7);
      return d;
    }
    render() {
      var ms = this.target() - new Date();
      if (ms < 0) ms = 0;
      var s = Math.floor(ms / 1000);
      var parts = [Math.floor(s / 86400), Math.floor(s % 86400 / 3600), Math.floor(s % 3600 / 60), s % 60];
      var labels = ['Tage', 'Std', 'Min', 'Sek'];
      var self = this;
      if (!this.built) {
        this.innerHTML = parts.map(function (_, i) {
          return '<span class="cd__unit"><span class="cd__num num" data-i="' + i + '">00</span><span class="cd__lbl">' + labels[i] + '</span></span>';
        }).join('<span class="cd__sep" aria-hidden="true">:</span>');
        this.built = true;
        this.setAttribute('aria-label', 'Countdown bis zum nächsten Drop');
      }
      parts.forEach(function (v, i) {
        var el = $('[data-i="' + i + '"]', self);
        var nv = String(v).padStart(2, '0');
        if (el && el.textContent !== nv) el.textContent = nv;
      });
    }
  });

  /* ---------- <sticky-atc> ---------- */
  customElements.define('sticky-atc', class extends HTMLElement {
    connectedCallback() {
      var watch = document.querySelector('[data-atc-anchor]');
      if (!watch) return;
      var io = new IntersectionObserver((es) => {
        this.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0);
      }, { rootMargin: '0px' });
      io.observe(watch);
    }
  });

  /* ---------- <image-zoom> ---------- */
  customElements.define('image-zoom', class extends HTMLElement {
    connectedCallback() {
      if (matchMedia('(hover: none)').matches || reduced) return;
      var img = $('img', this);
      if (!img) return;
      this.addEventListener('pointermove', (e) => {
        var r = this.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      this.addEventListener('pointerenter', () => this.classList.add('is-zoom'));
      this.addEventListener('pointerleave', () => { this.classList.remove('is-zoom'); img.style.transformOrigin = 'center'; });
    }
  });

  /* ---------- gallery ---------- */
  customElements.define('product-gallery', class extends HTMLElement {
    connectedCallback() {
      var main = $('[data-gallery-main] img', this);
      $$('[data-thumb]', this).forEach((b, i) => b.addEventListener('click', () => {
        $$('[data-thumb]', this).forEach((x) => x.setAttribute('aria-current', 'false'));
        b.setAttribute('aria-current', 'true');
        if (main) { main.src = b.dataset.thumb; main.srcset = ''; main.alt = b.dataset.alt || main.alt; }
      }));
    }
  });

  /* ---------- rails with arrow buttons ---------- */
  customElements.define('rail-carousel', class extends HTMLElement {
    connectedCallback() {
      this.rail = $('.rail', this);
      this.prev = $('[data-rail-prev]', this.closest('section') || this);
      this.next = $('[data-rail-next]', this.closest('section') || this);
      if (!this.rail) return;
      var step = () => (this.rail.firstElementChild ? this.rail.firstElementChild.offsetWidth + 16 : 300);
      if (this.prev) this.prev.addEventListener('click', () => this.rail.scrollBy({ left: -step() * 2, behavior: reduced ? 'auto' : 'smooth' }));
      if (this.next) this.next.addEventListener('click', () => this.rail.scrollBy({ left: step() * 2, behavior: reduced ? 'auto' : 'smooth' }));
      this.rail.addEventListener('scroll', () => this.sync(), { passive: true });
      this.sync();
      addEventListener('resize', () => this.sync(), { passive: true });
    }
    sync() {
      if (!this.prev || !this.next) return;
      var r = this.rail;
      this.prev.toggleAttribute('disabled', r.scrollLeft < 8);
      this.next.toggleAttribute('disabled', r.scrollLeft + r.clientWidth >= r.scrollWidth - 8);
    }
  });

  /* ---------- wishlist ----------
     Only signed-in customers can save favourites. Storage is per customer in
     localStorage until a wishlist app takes over: an app can register
     window.MatoshiWishlist = { list(), toggle(handle) } and we defer to it. */
  var CUSTOMER = document.documentElement.getAttribute('data-customer');
  var WK = 'matoshi.wishlist.' + (CUSTOMER || 'guest');
  function wl() {
    if (window.MatoshiWishlist && window.MatoshiWishlist.list) return window.MatoshiWishlist.list() || [];
    try { return JSON.parse(localStorage.getItem(WK)) || []; } catch (e) { return []; }
  }
  function wlSet(a) { try { localStorage.setItem(WK, JSON.stringify(a)); } catch (e) {} }
  function paintWishlist() {
    var list = wl();
    $$('[data-wish]').forEach(function (b) {
      var on = list.indexOf(b.dataset.wish) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on);
    });
    $$('[data-wish-count]').forEach(function (c) { c.textContent = list.length; c.toggleAttribute('hidden', !list.length); });
    document.dispatchEvent(new CustomEvent('matoshi:wishlist', { detail: list }));
  }
  function wishGate(trigger) {
    var gate = $('[data-wish-gate]');
    if (!gate) { location.href = '/account/login'; return; }
    gate.removeAttribute('hidden');
    requestAnimationFrame(function () { gate.classList.add('is-on'); var card = $('.wgate__card', gate); if (card) card.focus({ preventScroll: true }); });
    var release = trap(gate, close);
    function close() {
      gate.classList.remove('is-on'); release();
      setTimeout(function () { gate.setAttribute('hidden', ''); }, 260);
      if (trigger && trigger.focus) trigger.focus();
    }
    $$('[data-wish-gate-close]', gate).forEach(function (b) { b.onclick = close; });
    gate.onclick = function (e) { if (e.target === gate) close(); };
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    if (!CUSTOMER) { wishGate(b); return; }
    var h = b.dataset.wish;
    if (window.MatoshiWishlist && window.MatoshiWishlist.toggle) { window.MatoshiWishlist.toggle(h); paintWishlist(); return; }
    var list = wl(), i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else { list.push(h); burst(b); try { if (navigator.vibrate) navigator.vibrate(8); } catch (err) {} }
    wlSet(list); paintWishlist();
  });
  window.MatoshiFavorites = { list: wl, remove: function (h) { var l = wl().filter(function (x) { return x !== h; }); wlSet(l); paintWishlist(); }, paint: paintWishlist };

  /* ---------- recently viewed ---------- */
  var RK = 'matoshi.recent.v1';
  function recent() { try { return JSON.parse(localStorage.getItem(RK)) || []; } catch (e) { return []; } }
  function pushRecent(h) {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || !privacy.preferencesProcessingAllowed || !privacy.preferencesProcessingAllowed()) return;
    var l = recent().filter(function (x) { return x !== h; });
    l.unshift(h); wlSetKey(RK, l.slice(0, 10));
  }
  function wlSetKey(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  window.MatoshiRecent = { list: recent, push: pushRecent };

  /* ---------- restock notify panel ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-notify-open]');
    if (!b) return;
    var panel = document.getElementById(b.getAttribute('aria-controls') || 'NotifyPanel') || $('[data-notify]');
    if (!panel) return;
    panel.removeAttribute('hidden');
    $$('[data-notify-open]').forEach(function (x) { x.setAttribute('aria-expanded', 'true'); });
    panel.classList.remove('is-pulse'); void panel.offsetWidth; panel.classList.add('is-pulse');
    panel.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
    var input = panel.querySelector('input[type=email]');
    if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, reduced ? 0 : 450);
  });

  /* ---------- newsletter / notify forms ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-fake-form]');
    if (!f) return;
    e.preventDefault();
    var input = f.querySelector('input[type=email]');
    var msg = f.parentElement.querySelector('[data-form-msg]');
    if (input && !/^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(input.value)) {
      if (msg) { msg.className = 'form-msg form-msg--err'; msg.textContent = "Das hat nicht geklappt. Prüf die E-Mail und versuch's nochmal."; }
      input.focus();
      return;
    }
    if (msg) { msg.className = 'form-msg form-msg--ok'; msg.textContent = f.dataset.successMsg || 'Drop-Alarm ist an. Willkommen in der Crew.'; }
    burst(f.querySelector('button') || f);
    f.reset();
  });

  document.addEventListener('DOMContentLoaded', function () {
    paintWishlist();
    var h = document.body.getAttribute('data-product-handle');
    if (h) pushRecent(h);
    renderRecent();
  });

  function renderRecent() {
    var host = document.querySelector('[data-recent-host]');
    if (!host) return;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || !privacy.preferencesProcessingAllowed || !privacy.preferencesProcessingAllowed()) {
      var section = host.closest('section'); if (section) section.hidden = true;
      try { localStorage.removeItem(RK); } catch (e) {}
      return;
    }
    var cur = document.body.getAttribute('data-product-handle');
    var all = window.__MATOSHI_PRODUCTS__ || [];
    var list = recent().filter(function (x) { return x !== cur; })
      .map(function (h) { return all.find(function (p) { return p.handle === h; }); })
      .filter(Boolean).slice(0, 6);
    if (list.length < 2) { var s = host.closest('section'); if (s) s.setAttribute('hidden', ''); return; }
    var fmt = window.MatoshiCart.format;
    host.innerHTML = list.map(function (p) {
      return '<a class="rv" href="' + esc(p.url) + '"><span class="rv__img"><img src="' + esc(window.MatoshiImg(p.image)) + '" alt="" width="120" height="150" loading="lazy"></span>' +
        '<span class="rv__t">' + esc(p.title) + '</span><span class="rv__p num">' + fmt(p.price) + '</span></a>';
    }).join('');
  }
})();

/* ---------- <collection-filters> — client-side facets over the rendered grid ---------- */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  customElements.define('collection-filters', class extends HTMLElement {
    connectedCallback() {
      this.grid = $('[data-product-grid]');
      if (!this.grid) return;
      this.cards = $$('.pcard', this.grid).map(function (el) {
        var link = $('.pcard__title a', el);
        var handle = link ? link.getAttribute('href').replace(/\/$/, '').split('/').pop() : '';
        var data = (window.__MATOSHI_PRODUCTS__ || []).find(function (p) { return p.handle === handle; });
        return { el: el.parentElement && el.parentElement.classList.contains('rail__cell') ? el.parentElement : el, data: data };
      }).filter(function (c) { return c.data; });

      this.buildSeries();
      this.panel = $('#FilterPanel', this);
      $$('[data-filter-toggle]', this).forEach((b) => b.addEventListener('click', () => this.toggle()));
      $$('[data-filter-clear]').forEach((b) => b.addEventListener('click', () => this.clear()));
      this.addEventListener('change', () => this.apply());
      this.addEventListener('input', (e) => { if (e.target.type === 'number') this.apply(); });
      var sort = $('[data-sort]', this);
      if (sort) sort.addEventListener('change', () => this.sort(sort.value));
      // stays collapsed: products must be visible without a click
    }
    buildSeries() {
      var host = $('[data-facet-series]', this);
      if (!host) return;
      var seen = {};
      this.cards.forEach(function (c) { if (c.data.series) seen[c.data.series] = c.data.series_handle; });
      var names = Object.keys(seen).sort();
      if (names.length < 2) { var fs = host.closest('.fgroup'); if (fs) fs.setAttribute('hidden', ''); return; }
      host.innerHTML = names.map(function (n) {
        return '<label class="fchip"><input type="checkbox" data-facet="series" value="' + window.MatoshiEscape(n) + '"><span>' + window.MatoshiEscape(n) + '</span></label>';
      }).join('');
    }
    toggle(force) {
      var btn = $('[data-filter-toggle]', this);
      var open = typeof force === 'boolean' ? force : this.panel.hasAttribute('hidden');
      this.panel.toggleAttribute('hidden', !open);
      if (btn) btn.setAttribute('aria-expanded', open);
      this.classList.toggle('is-open', open);
    }
    picked(name) {
      return $$('[data-facet="' + name + '"]:checked', this).map(function (i) { return i.value; });
    }
    apply() {
      var types = this.picked('type'), series = this.picked('series'), vendors = this.picked('vendor'), avail = this.picked('avail');
      var min = parseFloat(($('[data-price-min]', this) || {}).value) || 0;
      var max = parseFloat(($('[data-price-max]', this) || {}).value) || Infinity;
      var n = 0;
      this.cards.forEach(function (c) {
        var d = c.data, ok = true;
        if (types.length && types.indexOf(d.type) < 0) ok = false;
        if (series.length && series.indexOf(d.series) < 0) ok = false;
        if (vendors.length && vendors.indexOf(d.vendor) < 0) ok = false;
        if (avail.length) {
          var m = (avail.indexOf('in') > -1 && d.available && !d.preorder) || (avail.indexOf('pre') > -1 && d.preorder);
          if (!m) ok = false;
        }
        var eur = d.price / 100;
        if (eur < min || eur > max) ok = false;
        c.el.toggleAttribute('hidden', !ok);
        if (ok) n++;
      });
      var cnt = $('[data-result-count]', this);
      if (cnt) cnt.textContent = n + ' Produkte';
      var active = types.length + series.length + vendors.length + avail.length + (min ? 1 : 0) + (max !== Infinity ? 1 : 0);
      var badge = $('[data-filter-count]', this);
      if (badge) { badge.textContent = active; badge.toggleAttribute('hidden', !active); }
      var empty = $('[data-grid-empty]');
      if (empty) empty.toggleAttribute('hidden', n !== 0);
    }
    clear() {
      $$('input[type=checkbox]', this).forEach(function (i) { i.checked = false; });
      $$('input[type=number]', this).forEach(function (i) { i.value = ''; });
      this.apply();
    }
    sort(mode) {
      var cards = this.cards.slice();
      var key = {
        'price-ascending': function (a, b) { return a.data.price - b.data.price; },
        'price-descending': function (a, b) { return b.data.price - a.data.price; },
        'created-descending': function (a, b) { return new Date(b.data.created_at) - new Date(a.data.created_at); },
        'best-selling': function (a, b) { return (b.data.tags.indexOf('bestseller') > -1) - (a.data.tags.indexOf('bestseller') > -1); },
      }[mode];
      if (key) cards.sort(key);
      var g = this.grid;
      cards.forEach(function (c) { g.appendChild(c.el); });
    }
  });
})();

/* ---------- <product-tabs> — switch between two curated grids ---------- */
(function () {
  'use strict';
  customElements.define('product-tabs', class extends HTMLElement {
    connectedCallback() {
      this.panels = Array.prototype.slice.call(this.querySelectorAll('.ptabs__panel'));
      var head = this.closest('section');
      this.tabs = head ? Array.prototype.slice.call(head.querySelectorAll('.ptabs__tab')) : [];
      if (this.tabs.length < 2) return;
      var self = this;
      this.tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { self.select(i); });
        t.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var next = (i + d + self.tabs.length) % self.tabs.length;
          self.select(next);
          self.tabs[next].focus();
        });
      });
    }
    select(index) {
      var self = this;
      this.tabs.forEach(function (t, i) {
        var on = i === index;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach(function (p, i) {
        p.toggleAttribute('hidden', i !== index);
      });
      // newly shown cards need their reveal + wishlist state bound
      if (window.MatoshiReveal) window.MatoshiReveal(this.panels[index]);
      var shown = this.panels[index];
      if (shown) Array.prototype.forEach.call(shown.querySelectorAll('[data-reveal]'), function (el) { el.classList.add('is-in'); });
    }
  });
})();
